// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs_container__N_0_o","mainTabs":"Tabs_mainTabs__Czs_8"};